import React from "react";
import Grid from "@mui/material/Grid";

function FAQ() {
  return (
    <Grid container spacing={0}>
      Faq content
    </Grid>
  );
}

export default FAQ;
